import React from "react"
import strings from "../../localization/strings"
import RecordFilterSelector from "../../components/record/RecordFilterSelector"
import { ERecordSearchFilter, IDateRange, EDayOfWeek } from "../../models"
import TimeActionBar from "../common/TimeActionBar/TimeActionBar"
import { Toggle } from "material-ui"

interface IProps {
    loading: boolean
    selectedFilter: ERecordSearchFilter
    showThumbnail: boolean
    handleChangeSelectedFilter(selectedFilter: ERecordSearchFilter): void
    handleChangeShowThumbnail(showThumbnail: boolean): void
    reload(): void

    dateRange: IDateRange
    handleChangeDateRange(dateRange: IDateRange): void

    handleDownload?(): void
}

const RecordTableActionBar: React.SFC<IProps> = (props: IProps) => {
    const showThumbnailToggle = (
        <Toggle
            data-intercom-target={"Recor-Toggle-Show-Thumbnail"}
            toggled={props.showThumbnail}
            onToggle={(e, value) => props.handleChangeShowThumbnail(value)}
            labelPosition="left"
            label={strings.Show_Thumbnail}
            style={{ maxWidth: 200 }}
            labelStyle={{ whiteSpace: "nowrap" }}
        />
    )
    const actionPart = (
        <div style={{ display: "flex" }}>
            <div style={{ marginTop: -35 }}>
                <RecordFilterSelector
                    readonly={props.loading}
                    selectedFilter={props.selectedFilter}
                    handleChange={props.handleChangeSelectedFilter}
                />
            </div>
            <div title={strings.Refresh} style={{ marginLeft: 20 }} onClick={props.reload}>
                <i style={{ fontSize: 25 }} className="fa fa-refresh itemActionButton" />
            </div>
            {props.handleDownload &&
                <div
                    title={strings.Download}
                    style={{ marginLeft: "20px" }}
                    onClick={props.handleDownload}
                >
                    <i style={{ fontSize: 25 }} className="fa fa-download itemActionButton" />
                </div>
            }
        </div>
    )
    return (
        <div>
            {props.dateRange ?
                <div style={{ height: 100, position: "relative" }}>
                    <div style={{ position: "absolute", top: 15, right: 20 }}>
                        {showThumbnailToggle}
                    </div>
                    <div style={{ padding: 20, paddingLeft: 35 }}>
                        <span style={{ fontSize: 25, fontWeight: "bold" }}>{strings.Records}</span>
                    </div>
                    <div style={{ paddingRight: 20, display: "flex", justifyContent: "space-between", alignItems: "flex-end", marginTop: -25 }}>
                        <TimeActionBar
                            referenceDate={props.dateRange.StartDate}
                            handleChangeTimeRange={(startDate, endDate) => {
                                props.handleChangeDateRange({ StartDate: startDate, EndDate: endDate })
                            }}
                            startDayOfWeek={EDayOfWeek.Monday}
                            timeBarViewType={"week"}
                        />
                        {actionPart}
                    </div>
                </div> :
                <div style={{ height: 55, position: "relative" }}>
                    <div style={{ position: "absolute", top: -15, right: 20 }}>
                        {showThumbnailToggle}
                    </div>
                    <div style={{ padding: 20, paddingLeft: 35, display: "flex", justifyContent: "space-between" }}>
                        <span style={{ fontSize: 25, fontWeight: "bold" }}>{strings.Records}</span>
                        {actionPart}
                    </div>
                </div>
            }
        </div>
    )
}

export default RecordTableActionBar
